
    const version = '5.152.0-dcae08fc-int';
    export default version;
